/**
 * Copyright (c) 2010-2023 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { inject } from '@angular/core';
import { ClearBufferCommand } from './clear-buffer.command';
import { Store } from '@ngxs/store';
import { BufferService } from '../buffer.service';

export function clearBufferFactory() {
    const command = new ClearBufferCommand();
    command.setDependencies({
        store: inject(Store),
        bufferService: inject(BufferService),
    });
    return command;
}
